import styled from 'styled-components';

const StyledAgencyContainer = styled.div``;

export default StyledAgencyContainer;
